module.exports = __webpack_public_path__ + "img/banner-standapp-v2.f280f44f.svg";